import { useTheme } from '@/app/providers/ThemeProvider';
import logoDark from '@/assets/jenny-logo-dark.svg';
import logoLight from '@/assets/jenny-logo-light.svg';

export function JennyLogo({ className }: { className?: string }) {
  const { preferredMode } = useTheme();
  const src = preferredMode === 'dark' ? logoDark : logoLight;

  return <img src={src} alt="Jenny" className={className} />;
}
